import"./footer.css";
export default function footer() {
  return (
    <div className='bottom'>
       <div className='bottomleft'>
       <i className="bottomicon fa-brands fa-facebook"></i>
       <i className="bottomicon fa-brands fa-square-twitter"></i>
       <i className="bottomicon fa-brands fa-square-instagram"></i>
       <i class="bottomicon fa-solid fa-envelope"></i>
       
       </div>
    </div>
  )
}
